// BangkokPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import "../../styles/PhDCountry.css";
import DrpEduNavbar from "../../components/DrpEduNavbar";
const BangkokPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">
          🎓 PhD & Postdoc in Bangkok (Thailand)
        </h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Basic Information</h2>
          <ul>
            <li>
              <strong>Duration:</strong> 3 to 5 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Master’s degree in a relevant field</li>
                <li>English proficiency (TOEFL/IELTS) – e.g., IELTS 6.0+</li>
                <li>Research proposal, academic transcripts, and references</li>
              </ul>
            </li>
            <li>
              <strong>Medium of Instruction:</strong> Many programs taught in
              English, especially in international or research tracks
            </li>
            <li>
              <strong>Funding Options:</strong>
              <ul>
                <li>Thai Government Scholarships (TIPP)</li>
                <li>
                  University-funded scholarships or research assistantships
                </li>
                <li>Monthly stipends available through certain grants</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Basic Information</h2>
          <ul>
            <li>
              <strong>Duration:</strong> 1 to 3 years
            </li>
            <li>
              <strong>Eligibility:</strong> PhD in a relevant discipline with
              strong research output
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Funded by universities, government (NRCT, NSTDA), or foreign
                  collaborative grants
                </li>
                <li>
                  Salary: Typically USD 1,000–2,000/month, varies by field and
                  project
                </li>
              </ul>
            </li>
            <li>
              <strong>Fields in Demand:</strong> Medicine, Public Health,
              Renewable Energy, AI, Food Tech, Social Sciences
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in Bangkok</h2>
          <ol>
            <li>Chulalongkorn University</li>
            <li>Mahidol University</li>
            <li>Kasetsart University</li>
            <li>King Mongkut’s University of Technology Thonburi (KMUTT)</li>
            <li>Thammasat University</li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default BangkokPhD;
